/*
 * A type guard that ensure that the provided object is a valid error.
 * @see https://stackoverflow.com/questions/64452484/how-can-i-safely-access-caught-error-properties-in-typescript
 */
export function assertIsError(error: unknown): asserts error is Error {
  if (!(error instanceof Error)) {
    throw error
  }
}
